import React, {PureComponent, PropTypes} from 'react';
import cx from 'classnames';

import style from './login-form.module.css';

class LoginForm extends PureComponent {

    static propTypes = {
        onSubmit: PropTypes.func,
        error: PropTypes.string,
        success: PropTypes.bool,
        loading: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {

        const buttonText = (this.props.loading) ? '. . .' :  Exanimo.trans('do_password_reset');

        return (
            <div className={style.left}>
                <h2 className={style.smallHeader}>{Exanimo.trans('password_reset')}</h2>

                <form ref={(formNode) => this._form = formNode} onSubmit={this.props.onSubmit} action="">
                    {this.props.error && <div className={style.error}>{this.props.error}</div>}
                    {this.props.success && <div className={style.success}>{Exanimo.trans('success_reset')}</div>}
                    <input className={style.loginInput} type="text" placeholder={Exanimo.trans('username')} name="username"/>
                    <br/>
                    <input className={style.loginSubmit} type="submit" value={buttonText}/>
                </form>
            </div>
        );
    }
}

export default LoginForm;